unit dashboard.maintenance;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, VCL.TMSFNCTypes, VCL.TMSFNCUtils,
  VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, VCL.TMSFNCGridCell,
  VCL.TMSFNCGridOptions, XData.Web.Client, VCL.TMSFNCCustomComponent,
  VCL.TMSFNCCustomGrid, VCL.TMSFNCGridDatabaseAdapter, VCL.TMSFNCCustomControl,
  VCL.TMSFNCCustomScrollControl, VCL.TMSFNCGridData, VCL.TMSFNCGrid,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.ExtCtrls, Data.DB,
  WEBLib.DB, XData.Web.JsonDataset, XData.Web.Dataset, WEBLib.Buttons,
  System.Variants;

type
  TfrmDashBoardMaintenance = class(TForm)
    pTop: TPanel;
    pBottom: TPanel;
    pMain: TPanel;
    wcYears: TXDataWebClient;
    wdsYears: TXDataWebDataSet;
    dsYears: TDataSource;
    wcMonths: TXDataWebClient;
    wdsMonths: TXDataWebDataSet;
    dsMonths: TDataSource;
    wdsMonthsMonth: TIntegerField;
    wdsMonthsMonthName: TStringField;
    wdsYearsSelected: TBooleanField;
    wdsMonthsSelected: TBooleanField;
    wdsYearsYear: TIntegerField;
    pMainTop: TPanel;
    pMainMonths: TPanel;
    WebLabel2: TLabel;
    gMonths: TTMSFNCGrid;
    gdaMonths: TTMSFNCGridDatabaseAdapter;
    pMainYears: TPanel;
    WebLabel1: TLabel;
    gYears: TTMSFNCGrid;
    gdaYears: TTMSFNCGridDatabaseAdapter;
    pRegNo: TPanel;
    WebLabel3: TLabel;
    WebButton1: TButton;
    btnRegClear: TSpeedButton;
    wcReg: TXDataWebClient;
    wdsReg: TXDataWebDataSet;
    dsReg: TDataSource;
    wdsRegReg: TStringField;
    wdsRegFleetNo: TStringField;
    wdsRegFleetType: TStringField;
    wdsRegSelected: TBooleanField;
    WebTimer1: TTimer;
    wdsRegPriKey: TIntegerField;
    wdsTempReg: TXDataWebDataSet;
    StringField1: TStringField;
    StringField2: TStringField;
    StringField3: TStringField;
    BooleanField1: TBooleanField;
    IntegerField1: TIntegerField;
    pMaintTypes: TPanel;
    gSysTypes: TTMSFNCGrid;
    dsSysTypes: TDataSource;
    gdaSysTypes: TTMSFNCGridDatabaseAdapter;
    wcSysTypes: TXDataWebClient;
    wdsSysTypes: TXDataWebDataSet;
    wdsSysTypesSystemTypes: TStringField;
    wdsSysTypesSystemNo: TIntegerField;
    wdsSysTypesSelected: TBooleanField;
    gReg: TTMSFNCGrid;
    gdaReg: TTMSFNCGridDatabaseAdapter;
    WebLabel4: TLabel;
    pCostGroups: TPanel;
    TMSFNCGrid1: TTMSFNCGrid;
    gdaCostGroups: TTMSFNCGridDatabaseAdapter;
    WebLabel5: TLabel;
    wdsCostGroups: TXDataWebDataSet;
    wdsTempCostGroups: TXDataWebDataSet;
    dsCostGroups: TDataSource;
    WebSpeedButton1: TSpeedButton;
    WebSpeedButton2: TSpeedButton;
    procedure gYearsGetCellLayout(Sender: TObject; ACol, ARow: Integer;
      ALayout: TTMSFNCGridCellLayout; ACellState: TTMSFNCGridCellState);
    procedure gMonthsGetCellLayout(Sender: TObject; ACol, ARow: Integer;
      ALayout: TTMSFNCGridCellLayout; ACellState: TTMSFNCGridCellState);
    procedure WebFormShow(Sender: TObject);
    procedure WebFormResize(Sender: TObject);
    procedure gYearsCellDblClick(Sender: TObject; ACol, ARow: Integer);
    procedure gMonthsCellDblClick(Sender: TObject; ACol, ARow: Integer);
    procedure gRegGetCellLayout(Sender: TObject; ACol, ARow: Integer;
      ALayout: TTMSFNCGridCellLayout; ACellState: TTMSFNCGridCellState);
    procedure gRegCellDblClick(Sender: TObject; ACol, ARow: Integer);
    procedure btnRegClearClick(Sender: TObject);
    procedure wdsYearsAfterPost(DataSet: TDataSet);
    procedure wdsMonthsAfterPost(DataSet: TDataSet);
    procedure WebTimer1Timer(Sender: TObject);
    procedure wdsSysTypesAfterPost(DataSet: TDataSet);
    procedure gSysTypesCellDblClick(Sender: TObject; ACol, ARow: Integer);
    procedure gSysTypesGetCellLayout(Sender: TObject; ACol, ARow: Integer;
      ALayout: TTMSFNCGridCellLayout; ACellState: TTMSFNCGridCellState);
    procedure WebSpeedButton1Click(Sender: TObject);
    procedure WebSpeedButton2Click(Sender: TObject);
  private
    { Private declarations }
    procedure DoRegInfo;
    procedure TriggerTimer;
  public
    { Public declarations }
    procedure DoLoadYears;
    procedure DoLoadMonths;
    procedure DoLoadSystemTypes;
    procedure DoLoadCostGroups;
  protected procedure LoadDFMValues; override; end;

  TTMSFNCGridDataBaseAdapterOpen = class(TTMSFNCGridDataBaseAdapter);

var
  frmDashBoardMaintenance: TfrmDashBoardMaintenance;

implementation

{$R *.dfm}

uses
  stfmssystem.connection,
  share.common;

{ TfrmDashBoardMaintenance }

procedure TfrmDashBoardMaintenance.btnRegClearClick(Sender: TObject);
begin
  wdsReg.DisableControls;
  wdsReg.First;
  Repeat
    If wdsReg.FieldByName('Selected').asBoolean then
      begin
        wdsReg.Edit;
        wdsReg.FieldByName('Selected').asBoolean := False;
        wdsReg.Post;
      end;
    wdsReg.Next;
  Until wdsReg.Eof;
  wdsReg.First;
  wdsReg.EnableControls;
end;

procedure TfrmDashBoardMaintenance.DoLoadMonths;
  procedure OnResultMonths(Response : TXDataClientResponse);
  begin
    wdsMonths.Close;
    wdsMonths.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
    wdsMonths.Open;
    DoLoadSystemTypes;
  end;

begin
  wcMonths.RawInvoke('IdashboardService.GetMonths', [4], @OnResultMonths);
end;

procedure TfrmDashBoardMaintenance.DoLoadYears;
  procedure OnResultYears(Response : TXDataClientResponse);
  begin
    wdsYears.Close;
    wdsYears.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
    wdsYears.Open;
    DoLoadMonths;
  end;
begin
  wcYears.RawInvoke('IdashboardService.GetYears', [4], @OnResultYears);

end;

procedure TfrmDashBoardMaintenance.DoLoadSystemTypes;
  procedure OnResultSysTypes(Response : TXDataClientResponse);
  begin

    wdsSysTypes.Close;
    wdsSysTypes.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
    wdsSysTypes.Open;
  end;
begin
  wcSysTypes.RawInvoke('IdashboardService.GetSysTypes', [], @OnResultSysTypes);

end;
procedure TfrmDashBoardMaintenance.DoLoadCostGroups;
  procedure OnResultSysTypes(Response : TXDataClientResponse);
  begin

    wdsCostGroups.Close;
    wdsCostGroups.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
    wdsCostGroups.Open;
  end;
begin
  wcSysTypes.RawInvoke('IdashboardService.GetJobCostDesc', [], @OnResultSysTypes);

end;

procedure TfrmDashBoardMaintenance.DoRegInfo;
  procedure OnResult(Response : TXDataClientResponse);
    var
      iLastKey : Integer;
      iCurrentKey : Integer;
  begin
    If not wdsReg.Active then
      begin
        wdsReg.Close;
        wdsReg.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
        wdsReg.Open;
      end
    else
      begin
        wdsTempReg.Close;
        wdsTempReg.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
        wdsTempReg.Open;

        iCurrentKey := wdsReg.FieldByName('PriKey').asInteger;
        wdsReg.DisableControls;
        wdsTempReg.First;
        iLastKey := -1;
        Repeat
          If not wdsReg.Locate('PriKey', wdsTempReg.FieldByName('PriKey').asInteger,[]) then
            begin
              If iLastKey > -1 then
                begin
                  wdsReg.Locate('PriKey', iLastKey, []);
                  wdsReg.Insert;
                  wdsReg.FieldByName('Reg').asString       := wdsTempReg.FieldByName('Reg').asString;
                  wdsReg.FieldByName('FleetNo').asString   := wdsTempReg.FieldByName('FleetNo').asString;
                  wdsReg.FieldByName('FleetType').asString := wdsTempReg.FieldByName('FleetType').asString;
                  wdsReg.FieldByName('Selected').asBoolean := wdsTempReg.FieldByName('Selected').asBoolean;
                  wdsReg.FieldByName('PriKey').asInteger   := wdsTempReg.FieldByName('PriKey').asInteger;
                  wdsReg.Post;
                end
              else
                begin
                  wdsReg.First;
                  wdsReg.Insert;
                  wdsReg.FieldByName('Reg').asString       := wdsTempReg.FieldByName('Reg').asString;
                  wdsReg.FieldByName('FleetNo').asString   := wdsTempReg.FieldByName('FleetNo').asString;
                  wdsReg.FieldByName('FleetType').asString := wdsTempReg.FieldByName('FleetType').asString;
                  wdsReg.FieldByName('Selected').asBoolean := wdsTempReg.FieldByName('Selected').asBoolean;
                  wdsReg.FieldByName('PriKey').asInteger   := wdsTempReg.FieldByName('PriKey').asInteger;
                  wdsReg.Post;
                end;
            end;
          iLastKey := wdsTempReg.FieldByName('PriKey').asInteger;
          wdsTempReg.Next;
        Until wdsTempReg.Eof;
        wdsReg.Locate('PriKey', iCurrentKey, []);
        wdsTempReg.Close;
        wdsReg.EnableControls;
      end;
  end;
begin
  wcReg.RawInvoke('IdashboardService.GetReg', [4,GetJsonArrayFromDataSet(wdsYears,true,'Selected'),GetJsonArrayFromDataSet(wdsMonths,true,'Selected')], @OnResult);
end;

procedure TfrmDashBoardMaintenance.gMonthsCellDblClick(Sender: TObject; ACol,
  ARow: Integer);
  var
    d: TTMSFNCGridDataBaseAdapterOpen;
    ar : Integer;
    fName, fSuspended: TField;
    bSyspended : Boolean;
begin
  If ARow <= gMonths.FixedRows - 1 then
    Exit;

  d := TTMSFNCGridDataBaseAdapterOpen(gdaMonths);
  if d.CheckDataSet then
    begin
      ar := d.DataLink.ActiveRecord;
      try
        d.SetActiveRecord(ARow);
        fName := d.FieldAtColumn[0];
        if Assigned(fName) then
          begin
            If Trim(fName.AsString) <> '' then
              begin
                fSuspended := d.FieldAtColumn[2];
                if Assigned(fSuspended) then
                  begin
                    If fSuspended.AsBoolean then
                      begin
                        wdsMonths.Edit;
                        d.FieldAtColumn[2].asBoolean := False;
                        wdsMonths.Post;
                      end
                    else
                      begin
                        wdsMonths.Edit;
                        d.FieldAtColumn[2].asBoolean := True;
                        wdsMonths.Post;
                      end;
                  end;
              end;
          end;
      finally
        d.DataLink.ActiveRecord := ar;
      end;
    end;
end;

procedure TfrmDashBoardMaintenance.gMonthsGetCellLayout(Sender: TObject; ACol,
  ARow: Integer; ALayout: TTMSFNCGridCellLayout;
  ACellState: TTMSFNCGridCellState);
  var
    Bitmap : TTMSFNCBitmap;
    d: TTMSFNCGridDataBaseAdapterOpen;
    ar : Integer;
    fName, fSuspended: TField;
    bSyspended : Boolean;
begin
  If ARow <= gMonths.FixedRows - 1 then
    Exit;

  Try
    If ACol = 3 then
      begin
        d := TTMSFNCGridDataBaseAdapterOpen(gdaMonths);
        if d.CheckDataSet then
          begin
            ar := d.DataLink.ActiveRecord;
            try
              d.SetActiveRecord(ARow);
              fName := d.FieldAtColumn[0];
              if Assigned(fName) then
                begin
                  If Trim(fName.AsString) <> '' then
                    begin
                      fSuspended := d.FieldAtColumn[2];
                      if Assigned(fSuspended) then
                        begin
                          Bitmap := TTMSFNCBitmap.Create;
                          If fSuspended.AsBoolean then
                            Bitmap.LoadFromURL('images/status/green-switch.svg')
                          else
                            Bitmap.LoadFromURL('images/status/red-switch.svg');
                          gMonths.AddBitmap(ACol,ARow,Bitmap);
                          Bitmap.Free;
                        end;
                    end;
                end;
            finally
              d.DataLink.ActiveRecord := ar;
            end;
          end;
      end;
  except

  End;
end;

procedure TfrmDashBoardMaintenance.gRegCellDblClick(Sender: TObject; ACol,
  ARow: Integer);
  var
    d: TTMSFNCGridDataBaseAdapterOpen;
    ar : Integer;
    fName, fSuspended: TField;
    bSyspended : Boolean;
begin
  If ARow <= gReg.FixedRows - 1 then
    Exit;

  d := TTMSFNCGridDataBaseAdapterOpen(gdaReg);
  if d.CheckDataSet then
    begin
      ar := d.DataLink.ActiveRecord;
      try
        d.SetActiveRecord(ARow);
        fName := d.FieldAtColumn[0];
        if Assigned(fName) then
          begin
            If Trim(fName.AsString) <> '' then
              begin
                fSuspended := d.FieldAtColumn[2];
                if Assigned(fSuspended) then
                  begin
                    If fSuspended.AsBoolean then
                      begin
                        wdsReg.Edit;
                        d.FieldAtColumn[2].asBoolean := False;
                        wdsReg.Post;
                      end
                    else
                      begin
                        wdsReg.Edit;
                        d.FieldAtColumn[2].asBoolean := True;
                        wdsReg.Post;
                      end;
                  end;
              end;
          end;
      finally
        d.DataLink.ActiveRecord := ar;
      end;
    end;
end;

procedure TfrmDashBoardMaintenance.gRegGetCellLayout(Sender: TObject; ACol,
  ARow: Integer; ALayout: TTMSFNCGridCellLayout;
  ACellState: TTMSFNCGridCellState);
  var
    Bitmap : TTMSFNCBitmap;
    d: TTMSFNCGridDataBaseAdapterOpen;
    ar : Integer;
    fName, fSuspended: TField;
    bSyspended : Boolean;
begin
  If ARow <= gYears.FixedRows - 1 then
    Exit;
  Try
    If ACol = 3 then
      begin
        d := TTMSFNCGridDataBaseAdapterOpen(gdaReg);
        if d.CheckDataSet then
          begin
            ar := d.DataLink.ActiveRecord;
            try
              d.SetActiveRecord(ARow);
              fName := d.FieldAtColumn[0];
              if Assigned(fName) then
                begin
                  If Trim(fName.AsString) <> '' then
                    begin
                      fSuspended := d.FieldAtColumn[2];
                      if Assigned(fSuspended) then
                        begin
                          Bitmap := TTMSFNCBitmap.Create;
                          If fSuspended.AsBoolean then
                            Bitmap.LoadFromURL('images/status/green-switch.svg')
                          else
                            Bitmap.LoadFromURL('images/status/red-switch.svg');
                          gReg.AddBitmap(ACol,ARow,Bitmap);
                          Bitmap.Free;
                        end;
                    end;
                end;
            finally
              d.DataLink.ActiveRecord := ar;
            end;
          end;
      end;
  except

  End;
end;

procedure TfrmDashBoardMaintenance.gSysTypesCellDblClick(Sender: TObject; ACol,
  ARow: Integer);
 var
    d: TTMSFNCGridDataBaseAdapterOpen;
    ar : Integer;
    fName, fSuspended: TField;
    bSyspended : Boolean;
begin
  If ARow <= gSysTypes.FixedRows - 1 then
    Exit;

  d := TTMSFNCGridDataBaseAdapterOpen(gdaYears);
  if d.CheckDataSet then
    begin
      ar := d.DataLink.ActiveRecord;
      try
        d.SetActiveRecord(ARow);
        fName := d.FieldAtColumn[0];
        if Assigned(fName) then
          begin
            If Trim(fName.AsString) <> '' then
              begin
                fSuspended := d.FieldAtColumn[1];
                if Assigned(fSuspended) then
                  begin
                    If fSuspended.AsBoolean then
                      begin
                        wdsSysTypes.Edit;
                        d.FieldAtColumn[1].asBoolean := False;
                        wdsSysTypes.Post;
                      end
                    else
                      begin
                        wdsSysTypes.Edit;
                        d.FieldAtColumn[1].asBoolean := True;
                        wdsSysTypes.Post;
                      end;
                  end;
              end;
          end;
      finally
        d.DataLink.ActiveRecord := ar;
      end;
    end;
end;

procedure TfrmDashBoardMaintenance.gSysTypesGetCellLayout(Sender: TObject; ACol,
  ARow: Integer; ALayout: TTMSFNCGridCellLayout;
  ACellState: TTMSFNCGridCellState);
  var
    Bitmap : TTMSFNCBitmap;
    d: TTMSFNCGridDataBaseAdapterOpen;
    ar : Integer;
    fName, fSuspended: TField;
    bSyspended : Boolean;
begin
  If ARow <= gSysTypes.FixedRows - 1 then
    Exit;

  Try
    If ACol = 3 then
      begin
        d := TTMSFNCGridDataBaseAdapterOpen(gdaSysTypes);
        if d.CheckDataSet then
          begin
            ar := d.DataLink.ActiveRecord;
            try
              d.SetActiveRecord(ARow);
              fName := d.FieldAtColumn[0];
              if Assigned(fName) then
                begin
                  If Trim(fName.AsString) <> '' then
                    begin
                      fSuspended := d.FieldAtColumn[2];
                      if Assigned(fSuspended) then
                        begin
                          Bitmap := TTMSFNCBitmap.Create;
                          If fSuspended.AsBoolean then
                            Bitmap.LoadFromURL('images/status/green-switch.svg')
                          else
                            Bitmap.LoadFromURL('images/status/red-switch.svg');
                          gMonths.AddBitmap(ACol,ARow,Bitmap);
                          Bitmap.Free;
                        end;
                    end;
                end;
            finally
              d.DataLink.ActiveRecord := ar;
            end;
          end;
      end;
  except

  End;
end;


procedure TfrmDashBoardMaintenance.gYearsCellDblClick(Sender: TObject; ACol,
  ARow: Integer);
  var
    d: TTMSFNCGridDataBaseAdapterOpen;
    ar : Integer;
    fName, fSuspended: TField;
    bSyspended : Boolean;
begin
  If ARow <= gYears.FixedRows - 1 then
    Exit;

  d := TTMSFNCGridDataBaseAdapterOpen(gdaYears);
  if d.CheckDataSet then
    begin
      ar := d.DataLink.ActiveRecord;
      try
        d.SetActiveRecord(ARow);
        fName := d.FieldAtColumn[0];
        if Assigned(fName) then
          begin
            If Trim(fName.AsString) <> '' then
              begin
                fSuspended := d.FieldAtColumn[1];
                if Assigned(fSuspended) then
                  begin
                    If fSuspended.AsBoolean then
                      begin
                        wdsYears.Edit;
                        d.FieldAtColumn[1].asBoolean := False;
                        wdsYears.Post;
                      end
                    else
                      begin
                        wdsYears.Edit;
                        d.FieldAtColumn[1].asBoolean := True;
                        wdsYears.Post;
                      end;
                  end;
              end;
          end;
      finally
        d.DataLink.ActiveRecord := ar;
      end;
    end;
end;

procedure TfrmDashBoardMaintenance.gYearsGetCellLayout(Sender: TObject; ACol,
  ARow: Integer; ALayout: TTMSFNCGridCellLayout;
  ACellState: TTMSFNCGridCellState);
  var
    Bitmap : TTMSFNCBitmap;
    d: TTMSFNCGridDataBaseAdapterOpen;
    ar : Integer;
    fName, fSuspended: TField;
    bSyspended : Boolean;
begin
  If ARow <= gYears.FixedRows - 1 then
    Exit;
  Try
    If ACol = 2 then
      begin
        d := TTMSFNCGridDataBaseAdapterOpen(gdaYears);
        if d.CheckDataSet then
          begin
            ar := d.DataLink.ActiveRecord;
            try
              d.SetActiveRecord(ARow);
              fName := d.FieldAtColumn[0];
              if Assigned(fName) then
                begin
                  If Trim(fName.AsString) <> '' then
                    begin
                      fSuspended := d.FieldAtColumn[1];
                      if Assigned(fSuspended) then
                        begin
                          Bitmap := TTMSFNCBitmap.Create;
                          If fSuspended.AsBoolean then
                            Bitmap.LoadFromURL('images/status/green-switch.svg')
                          else
                            Bitmap.LoadFromURL('images/status/red-switch.svg');
                          gYears.AddBitmap(ACol,ARow,Bitmap);
                          Bitmap.Free;
                        end;
                    end;
                end;
            finally
              d.DataLink.ActiveRecord := ar;
            end;
          end;
      end;
  except

  End;
end;

procedure TfrmDashBoardMaintenance.TriggerTimer;
begin
  WebTimer1.Enabled := False;
  WebTimer1.Enabled := True;
end;

procedure TfrmDashBoardMaintenance.wdsMonthsAfterPost(DataSet: TDataSet);
begin
  TriggerTimer;
end;

procedure TfrmDashBoardMaintenance.wdsSysTypesAfterPost(DataSet: TDataSet);
begin
  TriggerTimer;
end;

procedure TfrmDashBoardMaintenance.wdsYearsAfterPost(DataSet: TDataSet);
begin
  TriggerTimer;
end;

procedure TfrmDashBoardMaintenance.WebFormResize(Sender: TObject);
begin
  pMainTop.Height := pMain.Height div 3;
end;

procedure TfrmDashBoardMaintenance.WebFormShow(Sender: TObject);
begin
  DoLoadYears;


end;

procedure TfrmDashBoardMaintenance.WebSpeedButton1Click(Sender: TObject);
begin
  wdssysTypes.DisableControls;
  wdssysTypes.First;
  Repeat
    If wdssysTypes.FieldByName('Selected').asBoolean then
      begin
        wdssysTypes.Edit;
        wdssysTypes.FieldByName('Selected').asBoolean := False;
        wdssysTypes.Post;
      end;
    wdssysTypes.Next;
  Until wdssysTypes.Eof;
  wdssysTypes.First;
  wdssysTypes.EnableControls;
end;

procedure TfrmDashBoardMaintenance.WebSpeedButton2Click(Sender: TObject);
begin
  wdsCostGroups.DisableControls;
  wdsCostGroups.First;
  Repeat
    If wdsCostGroups.FieldByName('Selected').asBoolean then
      begin
        wdsCostGroups.Edit;
        wdsCostGroups.FieldByName('Selected').asBoolean := False;
        wdsCostGroups.Post;
      end;
    wdsCostGroups.Next;
  Until wdsCostGroups.Eof;
  wdsCostGroups.First;
  wdsCostGroups.EnableControls;
end;

procedure TfrmDashBoardMaintenance.WebTimer1Timer(Sender: TObject);
begin
  WebTimer1.Enabled := False;
  DoRegInfo;
end;

procedure TfrmDashBoardMaintenance.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pTop := TPanel.Create(Self);
  pBottom := TPanel.Create(Self);
  pMain := TPanel.Create(Self);
  pMainTop := TPanel.Create(Self);
  pMainMonths := TPanel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  gMonths := TTMSFNCGrid.Create(Self);
  gdaMonths := TTMSFNCGridDatabaseAdapter.Create(Self);
  pMainYears := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  gYears := TTMSFNCGrid.Create(Self);
  gdaYears := TTMSFNCGridDatabaseAdapter.Create(Self);
  pRegNo := TPanel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  btnRegClear := TSpeedButton.Create(Self);
  gReg := TTMSFNCGrid.Create(Self);
  gdaReg := TTMSFNCGridDatabaseAdapter.Create(Self);
  pMaintTypes := TPanel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  gSysTypes := TTMSFNCGrid.Create(Self);
  gdaSysTypes := TTMSFNCGridDatabaseAdapter.Create(Self);
  WebSpeedButton1 := TSpeedButton.Create(Self);
  pCostGroups := TPanel.Create(Self);
  WebLabel5 := TLabel.Create(Self);
  TMSFNCGrid1 := TTMSFNCGrid.Create(Self);
  gdaCostGroups := TTMSFNCGridDatabaseAdapter.Create(Self);
  WebSpeedButton2 := TSpeedButton.Create(Self);
  WebButton1 := TButton.Create(Self);
  wcYears := TXDataWebClient.Create(Self);
  wdsYears := TXDataWebDataSet.Create(Self);
  wdsYearsSelected := TBooleanField.Create(Self);
  wdsYearsYear := TIntegerField.Create(Self);
  dsYears := TDataSource.Create(Self);
  wcMonths := TXDataWebClient.Create(Self);
  wdsMonths := TXDataWebDataSet.Create(Self);
  wdsMonthsMonth := TIntegerField.Create(Self);
  wdsMonthsMonthName := TStringField.Create(Self);
  wdsMonthsSelected := TBooleanField.Create(Self);
  dsMonths := TDataSource.Create(Self);
  wcReg := TXDataWebClient.Create(Self);
  wdsReg := TXDataWebDataSet.Create(Self);
  wdsRegReg := TStringField.Create(Self);
  wdsRegFleetNo := TStringField.Create(Self);
  wdsRegFleetType := TStringField.Create(Self);
  wdsRegSelected := TBooleanField.Create(Self);
  wdsRegPriKey := TIntegerField.Create(Self);
  dsReg := TDataSource.Create(Self);
  WebTimer1 := TTimer.Create(Self);
  wdsTempReg := TXDataWebDataSet.Create(Self);
  StringField1 := TStringField.Create(Self);
  StringField2 := TStringField.Create(Self);
  StringField3 := TStringField.Create(Self);
  BooleanField1 := TBooleanField.Create(Self);
  IntegerField1 := TIntegerField.Create(Self);
  dsSysTypes := TDataSource.Create(Self);
  wcSysTypes := TXDataWebClient.Create(Self);
  wdsSysTypes := TXDataWebDataSet.Create(Self);
  wdsSysTypesSystemNo := TIntegerField.Create(Self);
  wdsSysTypesSystemTypes := TStringField.Create(Self);
  wdsSysTypesSelected := TBooleanField.Create(Self);
  wdsCostGroups := TXDataWebDataSet.Create(Self);
  wdsTempCostGroups := TXDataWebDataSet.Create(Self);
  dsCostGroups := TDataSource.Create(Self);

  pTop.BeforeLoadDFMValues;
  pBottom.BeforeLoadDFMValues;
  pMain.BeforeLoadDFMValues;
  pMainTop.BeforeLoadDFMValues;
  pMainMonths.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  gMonths.BeforeLoadDFMValues;
  gdaMonths.BeforeLoadDFMValues;
  pMainYears.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  gYears.BeforeLoadDFMValues;
  gdaYears.BeforeLoadDFMValues;
  pRegNo.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  btnRegClear.BeforeLoadDFMValues;
  gReg.BeforeLoadDFMValues;
  gdaReg.BeforeLoadDFMValues;
  pMaintTypes.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  gSysTypes.BeforeLoadDFMValues;
  gdaSysTypes.BeforeLoadDFMValues;
  WebSpeedButton1.BeforeLoadDFMValues;
  pCostGroups.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  TMSFNCGrid1.BeforeLoadDFMValues;
  gdaCostGroups.BeforeLoadDFMValues;
  WebSpeedButton2.BeforeLoadDFMValues;
  WebButton1.BeforeLoadDFMValues;
  wcYears.BeforeLoadDFMValues;
  wdsYears.BeforeLoadDFMValues;
  wdsYearsSelected.BeforeLoadDFMValues;
  wdsYearsYear.BeforeLoadDFMValues;
  dsYears.BeforeLoadDFMValues;
  wcMonths.BeforeLoadDFMValues;
  wdsMonths.BeforeLoadDFMValues;
  wdsMonthsMonth.BeforeLoadDFMValues;
  wdsMonthsMonthName.BeforeLoadDFMValues;
  wdsMonthsSelected.BeforeLoadDFMValues;
  dsMonths.BeforeLoadDFMValues;
  wcReg.BeforeLoadDFMValues;
  wdsReg.BeforeLoadDFMValues;
  wdsRegReg.BeforeLoadDFMValues;
  wdsRegFleetNo.BeforeLoadDFMValues;
  wdsRegFleetType.BeforeLoadDFMValues;
  wdsRegSelected.BeforeLoadDFMValues;
  wdsRegPriKey.BeforeLoadDFMValues;
  dsReg.BeforeLoadDFMValues;
  WebTimer1.BeforeLoadDFMValues;
  wdsTempReg.BeforeLoadDFMValues;
  StringField1.BeforeLoadDFMValues;
  StringField2.BeforeLoadDFMValues;
  StringField3.BeforeLoadDFMValues;
  BooleanField1.BeforeLoadDFMValues;
  IntegerField1.BeforeLoadDFMValues;
  dsSysTypes.BeforeLoadDFMValues;
  wcSysTypes.BeforeLoadDFMValues;
  wdsSysTypes.BeforeLoadDFMValues;
  wdsSysTypesSystemNo.BeforeLoadDFMValues;
  wdsSysTypesSystemTypes.BeforeLoadDFMValues;
  wdsSysTypesSelected.BeforeLoadDFMValues;
  wdsCostGroups.BeforeLoadDFMValues;
  wdsTempCostGroups.BeforeLoadDFMValues;
  dsCostGroups.BeforeLoadDFMValues;
  try
    Name := 'frmDashBoardMaintenance';
    Width := 1119;
    Height := 578;
    SetEvent(Self, 'OnResize', 'WebFormResize');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    pTop.SetParentComponent(Self);
    pTop.Name := 'pTop';
    pTop.Left := 0;
    pTop.Top := 0;
    pTop.Width := 1119;
    pTop.Height := 41;
    pTop.Align := alTop;
    pTop.Caption := 'Maintenance Dashboard';
    pTop.Color := clSkyBlue;
    pTop.Font.Charset := DEFAULT_CHARSET;
    pTop.Font.Color := clWindowText;
    pTop.Font.Height := -12;
    pTop.Font.Name := 'Segoe UI';
    pTop.Font.Style := [fsBold];
    pTop.ParentFont := False;
    pTop.TabOrder := 0;
    pBottom.SetParentComponent(Self);
    pBottom.Name := 'pBottom';
    pBottom.Left := 0;
    pBottom.Top := 538;
    pBottom.Width := 1119;
    pBottom.Height := 40;
    pBottom.Align := alBottom;
    pBottom.ChildOrder := 1;
    pBottom.TabOrder := 1;
    pMain.SetParentComponent(Self);
    pMain.Name := 'pMain';
    pMain.Left := 0;
    pMain.Top := 41;
    pMain.Width := 1119;
    pMain.Height := 497;
    pMain.Align := alClient;
    pMain.ChildOrder := 2;
    pMain.TabOrder := 2;
    pMainTop.SetParentComponent(pMain);
    pMainTop.Name := 'pMainTop';
    pMainTop.Left := 0;
    pMainTop.Top := 0;
    pMainTop.Width := 1119;
    pMainTop.Height := 193;
    pMainTop.Align := alTop;
    pMainTop.BorderStyle := bsNone;
    pMainTop.ChildOrder := 2;
    pMainTop.TabOrder := 0;
    pMainMonths.SetParentComponent(pMainTop);
    pMainMonths.Name := 'pMainMonths';
    pMainMonths.Left := 161;
    pMainMonths.Top := 0;
    pMainMonths.Width := 161;
    pMainMonths.Height := 193;
    pMainMonths.Align := alLeft;
    pMainMonths.ChildOrder := 2;
    pMainMonths.TabOrder := 0;
    WebLabel2.SetParentComponent(pMainMonths);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 0;
    WebLabel2.Top := 0;
    WebLabel2.Width := 161;
    WebLabel2.Height := 15;
    WebLabel2.Align := alTop;
    WebLabel2.Alignment := taCenter;
    WebLabel2.Caption := 'Select Months';
    WebLabel2.Font.Charset := DEFAULT_CHARSET;
    WebLabel2.Font.Color := clWindowText;
    WebLabel2.Font.Height := -12;
    WebLabel2.Font.Name := 'Segoe UI';
    WebLabel2.Font.Style := [fsBold];
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.ParentFont := False;
    WebLabel2.WidthPercent := 100.000000000000000000;
    gMonths.SetParentComponent(pMainMonths);
    gMonths.Name := 'gMonths';
    gMonths.Left := 0;
    gMonths.Top := 15;
    gMonths.Width := 161;
    gMonths.Height := 178;
    gMonths.Align := alClient;
    gMonths.ParentDoubleBuffered := False;
    gMonths.DoubleBuffered := True;
    gMonths.TabOrder := 0;
    gMonths.DefaultRowHeight := 30.000000000000000000;
    gMonths.FixedColumns := 0;
    gMonths.ColumnCount := 2;
    gMonths.RowCount := 1;
    gMonths.Options.Bands.Enabled := True;
    gMonths.Options.Editing.CalcFormat := '%g';
    gMonths.Options.Editing.Enabled := False;
    gMonths.Options.Grouping.CalcFormat := '%g';
    gMonths.Options.Grouping.GroupCountFormat := '(%d)';
    gMonths.Options.IO.XMLEncoding := 'ISO-8859-1';
    gMonths.Options.Mouse.ClickMargin := 0;
    gMonths.Options.Mouse.ColumnSizeMargin := 6;
    gMonths.Options.Mouse.RowSizeMargin := 6;
    gMonths.Options.Selection.Mode := smRowRange;
    gMonths.Adapter := gdaCostGroups;
    gMonths.Columns.Clear;
    with gMonths.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      HorzAlignment := gtaCenter;
      ID := '';
      Width := 80.000000000000000000;
    end;
    with gMonths.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 0.000000000000000000;
    end;
    with gMonths.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 0.000000000000000000;
    end;
    with gMonths.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 50.000000000000000000;
    end;
    gMonths.DefaultFont.Charset := DEFAULT_CHARSET;
    gMonths.DefaultFont.Color := clWindowText;
    gMonths.DefaultFont.Height := -11;
    gMonths.DefaultFont.Name := 'Segoe UI';
    gMonths.DefaultFont.Style := [];
    gMonths.TopRow := 1;
    gMonths.Appearance.FixedLayout.Fill.Color := 16380654;
    gMonths.Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    gMonths.Appearance.FixedLayout.Font.Color := 4539717;
    gMonths.Appearance.FixedLayout.Font.Height := -13;
    gMonths.Appearance.FixedLayout.Font.Name := 'Segoe UI';
    gMonths.Appearance.FixedLayout.Font.Style := [fsBold];
    gMonths.Appearance.NormalLayout.Fill.Color := 16578806;
    gMonths.Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    gMonths.Appearance.NormalLayout.Font.Color := 8026746;
    gMonths.Appearance.NormalLayout.Font.Height := -11;
    gMonths.Appearance.NormalLayout.Font.Name := 'Segoe UI';
    gMonths.Appearance.NormalLayout.Font.Style := [];
    gMonths.Appearance.GroupLayout.Fill.Color := 12817262;
    gMonths.Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    gMonths.Appearance.GroupLayout.Font.Color := clBlack;
    gMonths.Appearance.GroupLayout.Font.Height := -11;
    gMonths.Appearance.GroupLayout.Font.Name := 'Segoe UI';
    gMonths.Appearance.GroupLayout.Font.Style := [];
    gMonths.Appearance.SummaryLayout.Fill.Color := 14009785;
    gMonths.Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    gMonths.Appearance.SummaryLayout.Font.Color := clBlack;
    gMonths.Appearance.SummaryLayout.Font.Height := -11;
    gMonths.Appearance.SummaryLayout.Font.Name := 'Segoe UI';
    gMonths.Appearance.SummaryLayout.Font.Style := [];
    gMonths.Appearance.SelectedLayout.Fill.Color := 16441019;
    gMonths.Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    gMonths.Appearance.SelectedLayout.Font.Color := 4539717;
    gMonths.Appearance.SelectedLayout.Font.Height := -11;
    gMonths.Appearance.SelectedLayout.Font.Name := 'Segoe UI';
    gMonths.Appearance.SelectedLayout.Font.Style := [];
    gMonths.Appearance.FocusedLayout.Fill.Color := 16039284;
    gMonths.Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    gMonths.Appearance.FocusedLayout.Font.Color := 4539717;
    gMonths.Appearance.FocusedLayout.Font.Height := -11;
    gMonths.Appearance.FocusedLayout.Font.Name := 'Segoe UI';
    gMonths.Appearance.FocusedLayout.Font.Style := [];
    gMonths.Appearance.FixedSelectedLayout.Fill.Color := clLightsteelblue;
    gMonths.Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    gMonths.Appearance.FixedSelectedLayout.Font.Color := clBlack;
    gMonths.Appearance.FixedSelectedLayout.Font.Height := -11;
    gMonths.Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    gMonths.Appearance.FixedSelectedLayout.Font.Style := [];
    gMonths.Appearance.BandLayout.Fill.Color := 16711679;
    gMonths.Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    gMonths.Appearance.BandLayout.Font.Color := 8026746;
    gMonths.Appearance.BandLayout.Font.Height := -11;
    gMonths.Appearance.BandLayout.Font.Name := 'Segoe UI';
    gMonths.Appearance.BandLayout.Font.Style := [];
    gMonths.Appearance.ProgressLayout.Format := '%.0f%%';
    gMonths.LeftCol := 0;
    gMonths.ScrollMode := scmItemScrolling;
    gMonths.DesignTimeSampleData := True;
    SetEvent(gMonths, Self, 'OnGetCellLayout', 'gMonthsGetCellLayout');
    SetEvent(gMonths, Self, 'OnCellDblClick', 'gMonthsCellDblClick');
    gdaMonths.SetParentComponent(gMonths);
    gdaMonths.Name := 'gdaMonths';
    gdaMonths.Left := 40;
    gdaMonths.Top := 64;
    gdaMonths.Width := 26;
    gdaMonths.Height := 26;
    gdaMonths.Visible := True;
    gdaMonths.Active := True;
    gdaMonths.Grid := gMonths;
    gdaMonths.DataSource := dsMonths;
    gdaMonths.Columns.Clear;
    with gdaMonths.Columns.Add do
    begin
      FieldName := 'MonthName';
      Header := 'Month';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaMonths.Columns.Add do
    begin
      FieldName := 'Month';
      Header := 'MonthNo';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaMonths.Columns.Add do
    begin
      FieldName := 'Selected';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaMonths.Columns.Add do
    begin
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    pMainYears.SetParentComponent(pMainTop);
    pMainYears.Name := 'pMainYears';
    pMainYears.Left := 0;
    pMainYears.Top := 0;
    pMainYears.Width := 161;
    pMainYears.Height := 193;
    pMainYears.Align := alLeft;
    pMainYears.BorderStyle := bsNone;
    pMainYears.ChildOrder := 1;
    pMainYears.TabOrder := 1;
    WebLabel1.SetParentComponent(pMainYears);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 0;
    WebLabel1.Top := 0;
    WebLabel1.Width := 161;
    WebLabel1.Height := 15;
    WebLabel1.Align := alTop;
    WebLabel1.Alignment := taCenter;
    WebLabel1.Caption := 'Select Years';
    WebLabel1.Font.Charset := DEFAULT_CHARSET;
    WebLabel1.Font.Color := clWindowText;
    WebLabel1.Font.Height := -12;
    WebLabel1.Font.Name := 'Segoe UI';
    WebLabel1.Font.Style := [fsBold];
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.ParentFont := False;
    WebLabel1.WidthPercent := 100.000000000000000000;
    gYears.SetParentComponent(pMainYears);
    gYears.Name := 'gYears';
    gYears.Left := 0;
    gYears.Top := 15;
    gYears.Width := 161;
    gYears.Height := 178;
    gYears.Align := alClient;
    gYears.ParentDoubleBuffered := False;
    gYears.DoubleBuffered := True;
    gYears.TabOrder := 0;
    gYears.DefaultRowHeight := 30.000000000000000000;
    gYears.FixedColumns := 0;
    gYears.ColumnCount := 2;
    gYears.RowCount := 1;
    gYears.Options.Bands.Enabled := True;
    gYears.Options.Editing.CalcFormat := '%g';
    gYears.Options.Editing.Enabled := False;
    gYears.Options.Grouping.CalcFormat := '%g';
    gYears.Options.Grouping.GroupCountFormat := '(%d)';
    gYears.Options.IO.XMLEncoding := 'ISO-8859-1';
    gYears.Options.Mouse.ClickMargin := 0;
    gYears.Options.Mouse.ColumnSizeMargin := 6;
    gYears.Options.Mouse.RowSizeMargin := 6;
    gYears.Options.Selection.Mode := smRowRange;
    gYears.Adapter := gdaYears;
    gYears.Columns.Clear;
    with gYears.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      HorzAlignment := gtaCenter;
      ID := '';
      Width := 80.000000000000000000;
    end;
    with gYears.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 0.000000000000000000;
    end;
    with gYears.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 50.000000000000000000;
    end;
    gYears.DefaultFont.Charset := DEFAULT_CHARSET;
    gYears.DefaultFont.Color := clWindowText;
    gYears.DefaultFont.Height := -11;
    gYears.DefaultFont.Name := 'Segoe UI';
    gYears.DefaultFont.Style := [];
    gYears.TopRow := 1;
    gYears.Appearance.FixedLayout.Fill.Color := 16380654;
    gYears.Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    gYears.Appearance.FixedLayout.Font.Color := 4539717;
    gYears.Appearance.FixedLayout.Font.Height := -13;
    gYears.Appearance.FixedLayout.Font.Name := 'Segoe UI';
    gYears.Appearance.FixedLayout.Font.Style := [fsBold];
    gYears.Appearance.NormalLayout.Fill.Color := 16578806;
    gYears.Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    gYears.Appearance.NormalLayout.Font.Color := 8026746;
    gYears.Appearance.NormalLayout.Font.Height := -11;
    gYears.Appearance.NormalLayout.Font.Name := 'Segoe UI';
    gYears.Appearance.NormalLayout.Font.Style := [];
    gYears.Appearance.GroupLayout.Fill.Color := 12817262;
    gYears.Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    gYears.Appearance.GroupLayout.Font.Color := clBlack;
    gYears.Appearance.GroupLayout.Font.Height := -11;
    gYears.Appearance.GroupLayout.Font.Name := 'Segoe UI';
    gYears.Appearance.GroupLayout.Font.Style := [];
    gYears.Appearance.SummaryLayout.Fill.Color := 14009785;
    gYears.Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    gYears.Appearance.SummaryLayout.Font.Color := clBlack;
    gYears.Appearance.SummaryLayout.Font.Height := -11;
    gYears.Appearance.SummaryLayout.Font.Name := 'Segoe UI';
    gYears.Appearance.SummaryLayout.Font.Style := [];
    gYears.Appearance.SelectedLayout.Fill.Color := 16441019;
    gYears.Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    gYears.Appearance.SelectedLayout.Font.Color := 4539717;
    gYears.Appearance.SelectedLayout.Font.Height := -11;
    gYears.Appearance.SelectedLayout.Font.Name := 'Segoe UI';
    gYears.Appearance.SelectedLayout.Font.Style := [];
    gYears.Appearance.FocusedLayout.Fill.Color := 16039284;
    gYears.Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    gYears.Appearance.FocusedLayout.Font.Color := 4539717;
    gYears.Appearance.FocusedLayout.Font.Height := -11;
    gYears.Appearance.FocusedLayout.Font.Name := 'Segoe UI';
    gYears.Appearance.FocusedLayout.Font.Style := [];
    gYears.Appearance.FixedSelectedLayout.Fill.Color := clLightsteelblue;
    gYears.Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    gYears.Appearance.FixedSelectedLayout.Font.Color := clBlack;
    gYears.Appearance.FixedSelectedLayout.Font.Height := -11;
    gYears.Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    gYears.Appearance.FixedSelectedLayout.Font.Style := [];
    gYears.Appearance.BandLayout.Fill.Color := 16711679;
    gYears.Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    gYears.Appearance.BandLayout.Font.Color := 8026746;
    gYears.Appearance.BandLayout.Font.Height := -11;
    gYears.Appearance.BandLayout.Font.Name := 'Segoe UI';
    gYears.Appearance.BandLayout.Font.Style := [];
    gYears.Appearance.ProgressLayout.Format := '%.0f%%';
    gYears.LeftCol := 0;
    gYears.ScrollMode := scmItemScrolling;
    gYears.DesignTimeSampleData := True;
    SetEvent(gYears, Self, 'OnGetCellLayout', 'gYearsGetCellLayout');
    SetEvent(gYears, Self, 'OnCellDblClick', 'gYearsCellDblClick');
    gdaYears.SetParentComponent(gYears);
    gdaYears.Name := 'gdaYears';
    gdaYears.Left := 40;
    gdaYears.Top := 40;
    gdaYears.Width := 26;
    gdaYears.Height := 26;
    gdaYears.Visible := True;
    gdaYears.Active := True;
    gdaYears.Grid := gYears;
    gdaYears.DataSource := dsYears;
    gdaYears.Columns.Clear;
    with gdaYears.Columns.Add do
    begin
      FieldName := 'Year';
      Header := 'Years';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaYears.Columns.Add do
    begin
      FieldName := 'Selected';
      Header := 'Selected';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaYears.Columns.Add do
    begin
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    pRegNo.SetParentComponent(pMainTop);
    pRegNo.Name := 'pRegNo';
    pRegNo.Left := 322;
    pRegNo.Top := 0;
    pRegNo.Width := 287;
    pRegNo.Height := 193;
    pRegNo.Align := alLeft;
    pRegNo.BorderStyle := bsNone;
    pRegNo.ChildOrder := 2;
    pRegNo.TabOrder := 2;
    WebLabel3.SetParentComponent(pRegNo);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 0;
    WebLabel3.Top := 0;
    WebLabel3.Width := 287;
    WebLabel3.Height := 15;
    WebLabel3.Align := alTop;
    WebLabel3.Alignment := taCenter;
    WebLabel3.Caption := 'Select Registration';
    WebLabel3.Font.Charset := DEFAULT_CHARSET;
    WebLabel3.Font.Color := clWindowText;
    WebLabel3.Font.Height := -12;
    WebLabel3.Font.Name := 'Segoe UI';
    WebLabel3.Font.Style := [fsBold];
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.ParentFont := False;
    WebLabel3.WidthPercent := 100.000000000000000000;
    btnRegClear.SetParentComponent(pRegNo);
    btnRegClear.Name := 'btnRegClear';
    btnRegClear.Left := 0;
    btnRegClear.Top := 169;
    btnRegClear.Width := 287;
    btnRegClear.Height := 24;
    btnRegClear.Align := alBottom;
    btnRegClear.Color := clNone;
    btnRegClear.HeightPercent := 100.000000000000000000;
    btnRegClear.TabOrder := 0;
    btnRegClear.WidthPercent := 100.000000000000000000;
    SetEvent(btnRegClear, Self, 'OnClick', 'btnRegClearClick');
    gReg.SetParentComponent(pRegNo);
    gReg.Name := 'gReg';
    gReg.Left := 0;
    gReg.Top := 15;
    gReg.Width := 287;
    gReg.Height := 154;
    gReg.Align := alClient;
    gReg.ParentDoubleBuffered := False;
    gReg.DoubleBuffered := True;
    gReg.TabOrder := 1;
    gReg.DefaultRowHeight := 30.000000000000000000;
    gReg.FixedColumns := 0;
    gReg.ColumnCount := 4;
    gReg.RowCount := 1;
    gReg.Options.Bands.Enabled := True;
    gReg.Options.Editing.CalcFormat := '%g';
    gReg.Options.Editing.Enabled := False;
    gReg.Options.Grouping.CalcFormat := '%g';
    gReg.Options.Grouping.GroupCountFormat := '(%d)';
    gReg.Options.IO.XMLEncoding := 'ISO-8859-1';
    gReg.Options.Mouse.ClickMargin := 0;
    gReg.Options.Mouse.ColumnSizeMargin := 6;
    gReg.Options.Mouse.RowSizeMargin := 6;
    gReg.Adapter := gdaReg;
    gReg.Columns.Clear;
    with gReg.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 70.000000000000000000;
    end;
    with gReg.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 100.000000000000000000;
    end;
    with gReg.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 0.000000000000000000;
    end;
    with gReg.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 50.000000000000000000;
    end;
    gReg.DefaultFont.Charset := DEFAULT_CHARSET;
    gReg.DefaultFont.Color := clWindowText;
    gReg.DefaultFont.Height := -11;
    gReg.DefaultFont.Name := 'Segoe UI';
    gReg.DefaultFont.Style := [];
    gReg.TopRow := 1;
    gReg.Appearance.FixedLayout.Fill.Color := 16380654;
    gReg.Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    gReg.Appearance.FixedLayout.Font.Color := 4539717;
    gReg.Appearance.FixedLayout.Font.Height := -13;
    gReg.Appearance.FixedLayout.Font.Name := 'Segoe UI';
    gReg.Appearance.FixedLayout.Font.Style := [fsBold];
    gReg.Appearance.NormalLayout.Fill.Color := 16578806;
    gReg.Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    gReg.Appearance.NormalLayout.Font.Color := 8026746;
    gReg.Appearance.NormalLayout.Font.Height := -11;
    gReg.Appearance.NormalLayout.Font.Name := 'Segoe UI';
    gReg.Appearance.NormalLayout.Font.Style := [];
    gReg.Appearance.GroupLayout.Fill.Color := 12817262;
    gReg.Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    gReg.Appearance.GroupLayout.Font.Color := clBlack;
    gReg.Appearance.GroupLayout.Font.Height := -11;
    gReg.Appearance.GroupLayout.Font.Name := 'Segoe UI';
    gReg.Appearance.GroupLayout.Font.Style := [];
    gReg.Appearance.SummaryLayout.Fill.Color := 14009785;
    gReg.Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    gReg.Appearance.SummaryLayout.Font.Color := clBlack;
    gReg.Appearance.SummaryLayout.Font.Height := -11;
    gReg.Appearance.SummaryLayout.Font.Name := 'Segoe UI';
    gReg.Appearance.SummaryLayout.Font.Style := [];
    gReg.Appearance.SelectedLayout.Fill.Color := 16441019;
    gReg.Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    gReg.Appearance.SelectedLayout.Font.Color := 4539717;
    gReg.Appearance.SelectedLayout.Font.Height := -11;
    gReg.Appearance.SelectedLayout.Font.Name := 'Segoe UI';
    gReg.Appearance.SelectedLayout.Font.Style := [];
    gReg.Appearance.FocusedLayout.Fill.Color := 16039284;
    gReg.Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    gReg.Appearance.FocusedLayout.Font.Color := 4539717;
    gReg.Appearance.FocusedLayout.Font.Height := -11;
    gReg.Appearance.FocusedLayout.Font.Name := 'Segoe UI';
    gReg.Appearance.FocusedLayout.Font.Style := [];
    gReg.Appearance.FixedSelectedLayout.Fill.Color := clLightsteelblue;
    gReg.Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    gReg.Appearance.FixedSelectedLayout.Font.Color := clBlack;
    gReg.Appearance.FixedSelectedLayout.Font.Height := -11;
    gReg.Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    gReg.Appearance.FixedSelectedLayout.Font.Style := [];
    gReg.Appearance.BandLayout.Fill.Color := 16711679;
    gReg.Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    gReg.Appearance.BandLayout.Font.Color := 8026746;
    gReg.Appearance.BandLayout.Font.Height := -11;
    gReg.Appearance.BandLayout.Font.Name := 'Segoe UI';
    gReg.Appearance.BandLayout.Font.Style := [];
    gReg.Appearance.ProgressLayout.Format := '%.0f%%';
    gReg.LeftCol := 0;
    gReg.ScrollMode := scmItemScrolling;
    gReg.DesignTimeSampleData := True;
    SetEvent(gReg, Self, 'OnGetCellLayout', 'gRegGetCellLayout');
    SetEvent(gReg, Self, 'OnCellDblClick', 'gRegCellDblClick');
    gdaReg.SetParentComponent(gReg);
    gdaReg.Name := 'gdaReg';
    gdaReg.Left := 104;
    gdaReg.Top := 64;
    gdaReg.Width := 26;
    gdaReg.Height := 26;
    gdaReg.Visible := True;
    gdaReg.Active := True;
    gdaReg.Grid := gReg;
    gdaReg.DataSource := dsReg;
    gdaReg.Columns.Clear;
    with gdaReg.Columns.Add do
    begin
      FieldName := 'FleetNo';
      Header := 'Fleet No';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaReg.Columns.Add do
    begin
      FieldName := 'Reg';
      Header := 'Reg No';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaReg.Columns.Add do
    begin
      FieldName := 'Selected';
      Header := 'Selected';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaReg.Columns.Add do
    begin
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    pMaintTypes.SetParentComponent(pMainTop);
    pMaintTypes.Name := 'pMaintTypes';
    pMaintTypes.Left := 609;
    pMaintTypes.Top := 0;
    pMaintTypes.Width := 240;
    pMaintTypes.Height := 193;
    pMaintTypes.Align := alLeft;
    pMaintTypes.ChildOrder := 3;
    pMaintTypes.TabOrder := 3;
    WebLabel4.SetParentComponent(pMaintTypes);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 0;
    WebLabel4.Top := 0;
    WebLabel4.Width := 240;
    WebLabel4.Height := 15;
    WebLabel4.Align := alTop;
    WebLabel4.Alignment := taCenter;
    WebLabel4.Caption := 'Select System Type';
    WebLabel4.Font.Charset := DEFAULT_CHARSET;
    WebLabel4.Font.Color := clWindowText;
    WebLabel4.Font.Height := -12;
    WebLabel4.Font.Name := 'Segoe UI';
    WebLabel4.Font.Style := [fsBold];
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.ParentFont := False;
    WebLabel4.WidthPercent := 100.000000000000000000;
    gSysTypes.SetParentComponent(pMaintTypes);
    gSysTypes.Name := 'gSysTypes';
    gSysTypes.Left := 0;
    gSysTypes.Top := 15;
    gSysTypes.Width := 240;
    gSysTypes.Height := 154;
    gSysTypes.Align := alClient;
    gSysTypes.ParentDoubleBuffered := False;
    gSysTypes.DoubleBuffered := True;
    gSysTypes.TabOrder := 0;
    gSysTypes.DefaultRowHeight := 40.000000000000000000;
    gSysTypes.FixedColumns := 0;
    gSysTypes.ColumnCount := 4;
    gSysTypes.RowCount := 1;
    gSysTypes.Options.Bands.Enabled := True;
    gSysTypes.Options.Editing.CalcFormat := '%g';
    gSysTypes.Options.Grouping.CalcFormat := '%g';
    gSysTypes.Options.Grouping.GroupCountFormat := '(%d)';
    gSysTypes.Options.IO.XMLEncoding := 'ISO-8859-1';
    gSysTypes.Options.Mouse.ClickMargin := 0;
    gSysTypes.Options.Mouse.ColumnSizeMargin := 6;
    gSysTypes.Options.Mouse.RowSizeMargin := 6;
    gSysTypes.Adapter := gdaSysTypes;
    gSysTypes.Columns.Clear;
    with gSysTypes.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 70.000000000000000000;
    end;
    with gSysTypes.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 100.000000000000000000;
    end;
    with gSysTypes.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 100.000000000000000000;
    end;
    with gSysTypes.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 68.000000000000000000;
    end;
    gSysTypes.DefaultFont.Charset := DEFAULT_CHARSET;
    gSysTypes.DefaultFont.Color := clWindowText;
    gSysTypes.DefaultFont.Height := -11;
    gSysTypes.DefaultFont.Name := 'Segoe UI';
    gSysTypes.DefaultFont.Style := [];
    gSysTypes.TopRow := 1;
    gSysTypes.Appearance.FixedLayout.Fill.Color := 16380654;
    gSysTypes.Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    gSysTypes.Appearance.FixedLayout.Font.Color := 4539717;
    gSysTypes.Appearance.FixedLayout.Font.Height := -13;
    gSysTypes.Appearance.FixedLayout.Font.Name := 'Segoe UI';
    gSysTypes.Appearance.FixedLayout.Font.Style := [fsBold];
    gSysTypes.Appearance.NormalLayout.Fill.Color := 16578806;
    gSysTypes.Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    gSysTypes.Appearance.NormalLayout.Font.Color := 8026746;
    gSysTypes.Appearance.NormalLayout.Font.Height := -11;
    gSysTypes.Appearance.NormalLayout.Font.Name := 'Segoe UI';
    gSysTypes.Appearance.NormalLayout.Font.Style := [];
    gSysTypes.Appearance.GroupLayout.Fill.Color := 12817262;
    gSysTypes.Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    gSysTypes.Appearance.GroupLayout.Font.Color := clBlack;
    gSysTypes.Appearance.GroupLayout.Font.Height := -11;
    gSysTypes.Appearance.GroupLayout.Font.Name := 'Segoe UI';
    gSysTypes.Appearance.GroupLayout.Font.Style := [];
    gSysTypes.Appearance.SummaryLayout.Fill.Color := 14009785;
    gSysTypes.Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    gSysTypes.Appearance.SummaryLayout.Font.Color := clBlack;
    gSysTypes.Appearance.SummaryLayout.Font.Height := -11;
    gSysTypes.Appearance.SummaryLayout.Font.Name := 'Segoe UI';
    gSysTypes.Appearance.SummaryLayout.Font.Style := [];
    gSysTypes.Appearance.SelectedLayout.Fill.Color := 16441019;
    gSysTypes.Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    gSysTypes.Appearance.SelectedLayout.Font.Color := 4539717;
    gSysTypes.Appearance.SelectedLayout.Font.Height := -11;
    gSysTypes.Appearance.SelectedLayout.Font.Name := 'Segoe UI';
    gSysTypes.Appearance.SelectedLayout.Font.Style := [];
    gSysTypes.Appearance.FocusedLayout.Fill.Color := 16039284;
    gSysTypes.Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    gSysTypes.Appearance.FocusedLayout.Font.Color := 4539717;
    gSysTypes.Appearance.FocusedLayout.Font.Height := -11;
    gSysTypes.Appearance.FocusedLayout.Font.Name := 'Segoe UI';
    gSysTypes.Appearance.FocusedLayout.Font.Style := [];
    gSysTypes.Appearance.FixedSelectedLayout.Fill.Color := clLightsteelblue;
    gSysTypes.Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    gSysTypes.Appearance.FixedSelectedLayout.Font.Color := clBlack;
    gSysTypes.Appearance.FixedSelectedLayout.Font.Height := -11;
    gSysTypes.Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    gSysTypes.Appearance.FixedSelectedLayout.Font.Style := [];
    gSysTypes.Appearance.BandLayout.Fill.Color := 16711679;
    gSysTypes.Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    gSysTypes.Appearance.BandLayout.Font.Color := 8026746;
    gSysTypes.Appearance.BandLayout.Font.Height := -11;
    gSysTypes.Appearance.BandLayout.Font.Name := 'Segoe UI';
    gSysTypes.Appearance.BandLayout.Font.Style := [];
    gSysTypes.Appearance.ProgressLayout.Format := '%.0f%%';
    gSysTypes.LeftCol := 0;
    gSysTypes.ScrollMode := scmItemScrolling;
    gSysTypes.DesignTimeSampleData := True;
    SetEvent(gSysTypes, Self, 'OnGetCellLayout', 'gSysTypesGetCellLayout');
    SetEvent(gSysTypes, Self, 'OnCellDblClick', 'gSysTypesCellDblClick');
    gdaSysTypes.SetParentComponent(gSysTypes);
    gdaSysTypes.Name := 'gdaSysTypes';
    gdaSysTypes.Left := 22;
    gdaSysTypes.Top := 40;
    gdaSysTypes.Width := 26;
    gdaSysTypes.Height := 26;
    gdaSysTypes.Visible := True;
    gdaSysTypes.Active := True;
    gdaSysTypes.Grid := gSysTypes;
    gdaSysTypes.DataSource := dsSysTypes;
    gdaSysTypes.Columns.Clear;
    with gdaSysTypes.Columns.Add do
    begin
      FieldName := 'SystemTypes';
      Header := 'System Types';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaSysTypes.Columns.Add do
    begin
      FieldName := 'Name';
      Header := 'Name';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaSysTypes.Columns.Add do
    begin
      FieldName := 'Selected';
      Header := 'Selected';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaSysTypes.Columns.Add do
    begin
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    WebSpeedButton1.SetParentComponent(pMaintTypes);
    WebSpeedButton1.Name := 'WebSpeedButton1';
    WebSpeedButton1.Left := 0;
    WebSpeedButton1.Top := 169;
    WebSpeedButton1.Width := 240;
    WebSpeedButton1.Height := 24;
    WebSpeedButton1.Align := alBottom;
    WebSpeedButton1.Color := clNone;
    WebSpeedButton1.HeightPercent := 100.000000000000000000;
    WebSpeedButton1.TabOrder := 1;
    WebSpeedButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton1, Self, 'OnClick', 'WebSpeedButton1Click');
    pCostGroups.SetParentComponent(pMainTop);
    pCostGroups.Name := 'pCostGroups';
    pCostGroups.Left := 849;
    pCostGroups.Top := 0;
    pCostGroups.Width := 270;
    pCostGroups.Height := 193;
    pCostGroups.Align := alClient;
    pCostGroups.ChildOrder := 4;
    pCostGroups.TabOrder := 4;
    WebLabel5.SetParentComponent(pCostGroups);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 0;
    WebLabel5.Top := 0;
    WebLabel5.Width := 270;
    WebLabel5.Height := 15;
    WebLabel5.Align := alTop;
    WebLabel5.Alignment := taCenter;
    WebLabel5.Caption := 'Cost Groups';
    WebLabel5.Font.Charset := DEFAULT_CHARSET;
    WebLabel5.Font.Color := clWindowText;
    WebLabel5.Font.Height := -12;
    WebLabel5.Font.Name := 'Segoe UI';
    WebLabel5.Font.Style := [fsBold];
    WebLabel5.HeightPercent := 100.000000000000000000;
    WebLabel5.ParentFont := False;
    WebLabel5.WidthPercent := 100.000000000000000000;
    TMSFNCGrid1.SetParentComponent(pCostGroups);
    TMSFNCGrid1.Name := 'TMSFNCGrid1';
    TMSFNCGrid1.Left := 0;
    TMSFNCGrid1.Top := 15;
    TMSFNCGrid1.Width := 270;
    TMSFNCGrid1.Height := 154;
    TMSFNCGrid1.Align := alClient;
    TMSFNCGrid1.ParentDoubleBuffered := False;
    TMSFNCGrid1.DoubleBuffered := True;
    TMSFNCGrid1.TabOrder := 0;
    TMSFNCGrid1.DefaultRowHeight := 40.000000000000000000;
    TMSFNCGrid1.FixedColumns := 0;
    TMSFNCGrid1.ColumnCount := 3;
    TMSFNCGrid1.Options.Bands.Enabled := True;
    TMSFNCGrid1.Options.Editing.CalcFormat := '%g';
    TMSFNCGrid1.Options.Grouping.CalcFormat := '%g';
    TMSFNCGrid1.Options.Grouping.GroupCountFormat := '(%d)';
    TMSFNCGrid1.Options.IO.XMLEncoding := 'ISO-8859-1';
    TMSFNCGrid1.Options.Mouse.ClickMargin := 0;
    TMSFNCGrid1.Options.Mouse.ColumnSizeMargin := 6;
    TMSFNCGrid1.Options.Mouse.RowSizeMargin := 6;
    TMSFNCGrid1.Adapter := gdaCostGroups;
    TMSFNCGrid1.Columns.Clear;
    with TMSFNCGrid1.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 70.000000000000000000;
    end;
    with TMSFNCGrid1.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 250.000000000000000000;
    end;
    with TMSFNCGrid1.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 100.000000000000000000;
    end;
    with TMSFNCGrid1.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 100.000000000000000000;
    end;
    TMSFNCGrid1.DefaultFont.Charset := DEFAULT_CHARSET;
    TMSFNCGrid1.DefaultFont.Color := clWindowText;
    TMSFNCGrid1.DefaultFont.Height := -11;
    TMSFNCGrid1.DefaultFont.Name := 'Segoe UI';
    TMSFNCGrid1.DefaultFont.Style := [];
    TMSFNCGrid1.TopRow := 1;
    TMSFNCGrid1.Appearance.FixedLayout.Fill.Color := 16380654;
    TMSFNCGrid1.Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCGrid1.Appearance.FixedLayout.Font.Color := 4539717;
    TMSFNCGrid1.Appearance.FixedLayout.Font.Height := -13;
    TMSFNCGrid1.Appearance.FixedLayout.Font.Name := 'Segoe UI';
    TMSFNCGrid1.Appearance.FixedLayout.Font.Style := [fsBold];
    TMSFNCGrid1.Appearance.NormalLayout.Fill.Color := 16578806;
    TMSFNCGrid1.Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCGrid1.Appearance.NormalLayout.Font.Color := 8026746;
    TMSFNCGrid1.Appearance.NormalLayout.Font.Height := -11;
    TMSFNCGrid1.Appearance.NormalLayout.Font.Name := 'Segoe UI';
    TMSFNCGrid1.Appearance.NormalLayout.Font.Style := [];
    TMSFNCGrid1.Appearance.GroupLayout.Fill.Color := 12817262;
    TMSFNCGrid1.Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCGrid1.Appearance.GroupLayout.Font.Color := clBlack;
    TMSFNCGrid1.Appearance.GroupLayout.Font.Height := -11;
    TMSFNCGrid1.Appearance.GroupLayout.Font.Name := 'Segoe UI';
    TMSFNCGrid1.Appearance.GroupLayout.Font.Style := [];
    TMSFNCGrid1.Appearance.SummaryLayout.Fill.Color := 14009785;
    TMSFNCGrid1.Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCGrid1.Appearance.SummaryLayout.Font.Color := clBlack;
    TMSFNCGrid1.Appearance.SummaryLayout.Font.Height := -11;
    TMSFNCGrid1.Appearance.SummaryLayout.Font.Name := 'Segoe UI';
    TMSFNCGrid1.Appearance.SummaryLayout.Font.Style := [];
    TMSFNCGrid1.Appearance.SelectedLayout.Fill.Color := 16441019;
    TMSFNCGrid1.Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCGrid1.Appearance.SelectedLayout.Font.Color := 4539717;
    TMSFNCGrid1.Appearance.SelectedLayout.Font.Height := -11;
    TMSFNCGrid1.Appearance.SelectedLayout.Font.Name := 'Segoe UI';
    TMSFNCGrid1.Appearance.SelectedLayout.Font.Style := [];
    TMSFNCGrid1.Appearance.FocusedLayout.Fill.Color := 16039284;
    TMSFNCGrid1.Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCGrid1.Appearance.FocusedLayout.Font.Color := 4539717;
    TMSFNCGrid1.Appearance.FocusedLayout.Font.Height := -11;
    TMSFNCGrid1.Appearance.FocusedLayout.Font.Name := 'Segoe UI';
    TMSFNCGrid1.Appearance.FocusedLayout.Font.Style := [];
    TMSFNCGrid1.Appearance.FixedSelectedLayout.Fill.Color := clLightsteelblue;
    TMSFNCGrid1.Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCGrid1.Appearance.FixedSelectedLayout.Font.Color := clBlack;
    TMSFNCGrid1.Appearance.FixedSelectedLayout.Font.Height := -11;
    TMSFNCGrid1.Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    TMSFNCGrid1.Appearance.FixedSelectedLayout.Font.Style := [];
    TMSFNCGrid1.Appearance.BandLayout.Fill.Color := 16711679;
    TMSFNCGrid1.Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCGrid1.Appearance.BandLayout.Font.Color := 8026746;
    TMSFNCGrid1.Appearance.BandLayout.Font.Height := -11;
    TMSFNCGrid1.Appearance.BandLayout.Font.Name := 'Segoe UI';
    TMSFNCGrid1.Appearance.BandLayout.Font.Style := [];
    TMSFNCGrid1.Appearance.ProgressLayout.Format := '%.0f%%';
    TMSFNCGrid1.LeftCol := 0;
    TMSFNCGrid1.ScrollMode := scmItemScrolling;
    TMSFNCGrid1.DesignTimeSampleData := True;
    gdaCostGroups.SetParentComponent(TMSFNCGrid1);
    gdaCostGroups.Name := 'gdaCostGroups';
    gdaCostGroups.Left := 6;
    gdaCostGroups.Top := 6;
    gdaCostGroups.Width := 26;
    gdaCostGroups.Height := 26;
    gdaCostGroups.Visible := True;
    gdaCostGroups.Grid := TMSFNCGrid1;
    gdaCostGroups.Columns.Clear;
    with gdaCostGroups.Columns.Add do
    begin
      FieldName := 'ID';
      Header := 'ID';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaCostGroups.Columns.Add do
    begin
      FieldName := 'Name';
      Header := 'Name';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaCostGroups.Columns.Add do
    begin
      FieldName := 'Selected';
      Header := 'Selected';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaCostGroups.Columns.Add do
    begin
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    WebSpeedButton2.SetParentComponent(pCostGroups);
    WebSpeedButton2.Name := 'WebSpeedButton2';
    WebSpeedButton2.Left := 0;
    WebSpeedButton2.Top := 169;
    WebSpeedButton2.Width := 270;
    WebSpeedButton2.Height := 24;
    WebSpeedButton2.Align := alBottom;
    WebSpeedButton2.Color := clNone;
    WebSpeedButton2.HeightPercent := 100.000000000000000000;
    WebSpeedButton2.TabOrder := 1;
    WebSpeedButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton2, Self, 'OnClick', 'WebSpeedButton2Click');
    WebButton1.SetParentComponent(pMain);
    WebButton1.Name := 'WebButton1';
    WebButton1.Left := 322;
    WebButton1.Top := 264;
    WebButton1.Width := 96;
    WebButton1.Height := 25;
    WebButton1.Caption := 'WebButton1';
    WebButton1.ChildOrder := 1;
    WebButton1.HeightPercent := 100.000000000000000000;
    WebButton1.WidthPercent := 100.000000000000000000;
    wcYears.SetParentComponent(Self);
    wcYears.Name := 'wcYears';
    wcYears.Connection := dmData.dbConnect;
    wcYears.Left := 80;
    wcYears.Top := 80;
    wdsYears.SetParentComponent(Self);
    wdsYears.Name := 'wdsYears';
    wdsYears.AfterPost := wdsYearsAfterPost;
    wdsYears.Connection := dmData.dbConnect;
    wdsYears.Left := 80;
    wdsYears.Top := 144;
    wdsYearsSelected.SetParentComponent(wdsYears);
    wdsYearsSelected.Name := 'wdsYearsSelected';
    wdsYearsSelected.FieldName := 'Selected';
    wdsYearsYear.SetParentComponent(wdsYears);
    wdsYearsYear.Name := 'wdsYearsYear';
    wdsYearsYear.FieldName := 'Year';
    dsYears.SetParentComponent(Self);
    dsYears.Name := 'dsYears';
    dsYears.AutoEdit := False;
    dsYears.DataSet := wdsYears;
    dsYears.Left := 56;
    dsYears.Top := 200;
    wcMonths.SetParentComponent(Self);
    wcMonths.Name := 'wcMonths';
    wcMonths.Connection := dmData.dbConnect;
    wcMonths.Left := 177;
    wcMonths.Top := 88;
    wdsMonths.SetParentComponent(Self);
    wdsMonths.Name := 'wdsMonths';
    wdsMonths.AfterPost := wdsMonthsAfterPost;
    wdsMonths.Connection := dmData.dbConnect;
    wdsMonths.Left := 169;
    wdsMonths.Top := 176;
    wdsMonthsMonth.SetParentComponent(wdsMonths);
    wdsMonthsMonth.Name := 'wdsMonthsMonth';
    wdsMonthsMonth.FieldName := 'Month';
    wdsMonthsMonthName.SetParentComponent(wdsMonths);
    wdsMonthsMonthName.Name := 'wdsMonthsMonthName';
    wdsMonthsMonthName.FieldName := 'MonthName';
    wdsMonthsSelected.SetParentComponent(wdsMonths);
    wdsMonthsSelected.Name := 'wdsMonthsSelected';
    wdsMonthsSelected.FieldName := 'Selected';
    dsMonths.SetParentComponent(Self);
    dsMonths.Name := 'dsMonths';
    dsMonths.AutoEdit := False;
    dsMonths.DataSet := wdsMonths;
    dsMonths.Left := 161;
    dsMonths.Top := 240;
    wcReg.SetParentComponent(Self);
    wcReg.Name := 'wcReg';
    wcReg.Connection := dmData.dbConnect;
    wcReg.Left := 362;
    wcReg.Top := 88;
    wdsReg.SetParentComponent(Self);
    wdsReg.Name := 'wdsReg';
    wdsReg.Connection := dmData.dbConnect;
    wdsReg.Left := 378;
    wdsReg.Top := 160;
    wdsRegReg.SetParentComponent(wdsReg);
    wdsRegReg.Name := 'wdsRegReg';
    wdsRegReg.FieldName := 'Reg';
    wdsRegFleetNo.SetParentComponent(wdsReg);
    wdsRegFleetNo.Name := 'wdsRegFleetNo';
    wdsRegFleetNo.FieldName := 'FleetNo';
    wdsRegFleetType.SetParentComponent(wdsReg);
    wdsRegFleetType.Name := 'wdsRegFleetType';
    wdsRegFleetType.FieldName := 'FleetType';
    wdsRegSelected.SetParentComponent(wdsReg);
    wdsRegSelected.Name := 'wdsRegSelected';
    wdsRegSelected.FieldName := 'Selected';
    wdsRegPriKey.SetParentComponent(wdsReg);
    wdsRegPriKey.Name := 'wdsRegPriKey';
    wdsRegPriKey.FieldName := 'PriKey';
    dsReg.SetParentComponent(Self);
    dsReg.Name := 'dsReg';
    dsReg.AutoEdit := False;
    dsReg.DataSet := wdsReg;
    dsReg.Left := 434;
    dsReg.Top := 160;
    WebTimer1.SetParentComponent(Self);
    WebTimer1.Name := 'WebTimer1';
    WebTimer1.Enabled := False;
    SetEvent(WebTimer1, Self, 'OnTimer', 'WebTimer1Timer');
    WebTimer1.Left := 504;
    WebTimer1.Top := 289;
    wdsTempReg.SetParentComponent(Self);
    wdsTempReg.Name := 'wdsTempReg';
    wdsTempReg.Connection := dmData.dbConnect;
    wdsTempReg.Left := 506;
    wdsTempReg.Top := 128;
    StringField1.SetParentComponent(wdsTempReg);
    StringField1.Name := 'StringField1';
    StringField1.FieldName := 'Reg';
    StringField2.SetParentComponent(wdsTempReg);
    StringField2.Name := 'StringField2';
    StringField2.FieldName := 'FleetNo';
    StringField3.SetParentComponent(wdsTempReg);
    StringField3.Name := 'StringField3';
    StringField3.FieldName := 'FleetType';
    BooleanField1.SetParentComponent(wdsTempReg);
    BooleanField1.Name := 'BooleanField1';
    BooleanField1.FieldName := 'Selected';
    IntegerField1.SetParentComponent(wdsTempReg);
    IntegerField1.Name := 'IntegerField1';
    IntegerField1.FieldName := 'PriKey';
    dsSysTypes.SetParentComponent(Self);
    dsSysTypes.Name := 'dsSysTypes';
    dsSysTypes.DataSet := wdsSysTypes;
    dsSysTypes.Left := 649;
    dsSysTypes.Top := 145;
    wcSysTypes.SetParentComponent(Self);
    wcSysTypes.Name := 'wcSysTypes';
    wcSysTypes.Connection := dmData.dbConnect;
    wcSysTypes.Left := 793;
    wcSysTypes.Top := 49;
    wdsSysTypes.SetParentComponent(Self);
    wdsSysTypes.Name := 'wdsSysTypes';
    wdsSysTypes.AfterPost := wdsSysTypesAfterPost;
    wdsSysTypes.Connection := dmData.dbConnect;
    wdsSysTypes.Left := 689;
    wdsSysTypes.Top := 81;
    wdsSysTypesSystemNo.SetParentComponent(wdsSysTypes);
    wdsSysTypesSystemNo.Name := 'wdsSysTypesSystemNo';
    wdsSysTypesSystemNo.FieldName := 'SystemNo';
    wdsSysTypesSystemTypes.SetParentComponent(wdsSysTypes);
    wdsSysTypesSystemTypes.Name := 'wdsSysTypesSystemTypes';
    wdsSysTypesSystemTypes.FieldName := 'SystemTypes';
    wdsSysTypesSelected.SetParentComponent(wdsSysTypes);
    wdsSysTypesSelected.Name := 'wdsSysTypesSelected';
    wdsSysTypesSelected.FieldName := 'Selected';
    wdsCostGroups.SetParentComponent(Self);
    wdsCostGroups.Name := 'wdsCostGroups';
    wdsCostGroups.Connection := dmData.dbConnect;
    wdsCostGroups.Left := 897;
    wdsCostGroups.Top := 64;
    wdsTempCostGroups.SetParentComponent(Self);
    wdsTempCostGroups.Name := 'wdsTempCostGroups';
    wdsTempCostGroups.Connection := dmData.dbConnect;
    wdsTempCostGroups.Left := 1009;
    wdsTempCostGroups.Top := 72;
    dsCostGroups.SetParentComponent(Self);
    dsCostGroups.Name := 'dsCostGroups';
    dsCostGroups.DataSet := wdsCostGroups;
    dsCostGroups.Left := 897;
    dsCostGroups.Top := 144;
  finally
    pTop.AfterLoadDFMValues;
    pBottom.AfterLoadDFMValues;
    pMain.AfterLoadDFMValues;
    pMainTop.AfterLoadDFMValues;
    pMainMonths.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    gMonths.AfterLoadDFMValues;
    gdaMonths.AfterLoadDFMValues;
    pMainYears.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    gYears.AfterLoadDFMValues;
    gdaYears.AfterLoadDFMValues;
    pRegNo.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    btnRegClear.AfterLoadDFMValues;
    gReg.AfterLoadDFMValues;
    gdaReg.AfterLoadDFMValues;
    pMaintTypes.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    gSysTypes.AfterLoadDFMValues;
    gdaSysTypes.AfterLoadDFMValues;
    WebSpeedButton1.AfterLoadDFMValues;
    pCostGroups.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    TMSFNCGrid1.AfterLoadDFMValues;
    gdaCostGroups.AfterLoadDFMValues;
    WebSpeedButton2.AfterLoadDFMValues;
    WebButton1.AfterLoadDFMValues;
    wcYears.AfterLoadDFMValues;
    wdsYears.AfterLoadDFMValues;
    wdsYearsSelected.AfterLoadDFMValues;
    wdsYearsYear.AfterLoadDFMValues;
    dsYears.AfterLoadDFMValues;
    wcMonths.AfterLoadDFMValues;
    wdsMonths.AfterLoadDFMValues;
    wdsMonthsMonth.AfterLoadDFMValues;
    wdsMonthsMonthName.AfterLoadDFMValues;
    wdsMonthsSelected.AfterLoadDFMValues;
    dsMonths.AfterLoadDFMValues;
    wcReg.AfterLoadDFMValues;
    wdsReg.AfterLoadDFMValues;
    wdsRegReg.AfterLoadDFMValues;
    wdsRegFleetNo.AfterLoadDFMValues;
    wdsRegFleetType.AfterLoadDFMValues;
    wdsRegSelected.AfterLoadDFMValues;
    wdsRegPriKey.AfterLoadDFMValues;
    dsReg.AfterLoadDFMValues;
    WebTimer1.AfterLoadDFMValues;
    wdsTempReg.AfterLoadDFMValues;
    StringField1.AfterLoadDFMValues;
    StringField2.AfterLoadDFMValues;
    StringField3.AfterLoadDFMValues;
    BooleanField1.AfterLoadDFMValues;
    IntegerField1.AfterLoadDFMValues;
    dsSysTypes.AfterLoadDFMValues;
    wcSysTypes.AfterLoadDFMValues;
    wdsSysTypes.AfterLoadDFMValues;
    wdsSysTypesSystemNo.AfterLoadDFMValues;
    wdsSysTypesSystemTypes.AfterLoadDFMValues;
    wdsSysTypesSelected.AfterLoadDFMValues;
    wdsCostGroups.AfterLoadDFMValues;
    wdsTempCostGroups.AfterLoadDFMValues;
    dsCostGroups.AfterLoadDFMValues;
  end;
end;

end.
